import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { HotjarService } from './shared/hotjar.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'body',
  template: `<router-outlet></router-outlet>`
})
export class AppComponent implements OnInit {
  constructor(
    private hotjarService: HotjarService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Listen for route changes
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // Initialize Hotjar only for specific pages
        this.hotjarService.initializeForPage(
          event.urlAfterRedirects, 
          environment.hotjarId
        );
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts